import React from 'react';
import { LiveManagedRuntime } from 'services/layer';
import { RuntimeContext } from './runtimeСontext';

export const useRuntime = (): LiveManagedRuntime => {
  const runtime = React.useContext(RuntimeContext);
  if (runtime === null) {
    throw new Error('useRuntime must be used within RuntimeProvider');
  }
  return runtime;
};
